<template>
  <el-dialog
    v-el-drag-dialog
    no="sendDestinationPortAgent"
    :visible.sync="innerVisible"
    :title="$t('FileHistory.SendDestinationPortAgent')"
    width="600px"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <span>{{ $t('CargoMsg.Cargo_MatchInstructionTip', [total, jobCount]) }}</span>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width: 100%;min-height: 350px;"
    />
    <span slot="footer">
      <el-button no="SendEmail" type="primary" @click="onSendEmail">{{ $t('FileHistory.SendEmail') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as jobExchangeAgentApi from '@/api/booking/jobExchangeAgent'

export default {
  name: 'DestinationAgentSelectDialog',
  props: {
    visible: { type: Boolean, required: true },
    rowData: { type: Array, required: true },
    total: { type: Number, default: 0 },
    jobCount: { type: Number, default: 0 }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          // 清除单选
          event.api.clearFocusedCell()
        },
        onCellFocused: (event) => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        }
      },
      columnDefs: [
        {
          headerName: this.$t('FileHistory.ProxyName'),
          field: 'destinationAgent',
          width: 350,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SelectJobCount'),
          field: 'count',
          width: 200
        }
      ],
      selectedNode: null
    }
  },
  computed: {
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.gridOptions.api.setFocusedCell(0, this.gridOptions.api.columnController.getAllDisplayedColumns()[0])
        this.selectedNode = this.gridOptions.api.rowModel.rowsToDisplay[0]
      }, 0)
    })
  },
  methods: {
    onSendEmail() {
      this.innerVisible = false
      this.$emit('callback', this.selectedRow.destinationAgent)
    }
  }
}
</script>
